/* file description */
import { Modal, Input, Tooltip, Button, Select, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { FC, useEffect, useState, useRef } from 'react';
import SPTableWithModel from '@/components/SPTableWithModel';
import { SPTableBaseMode } from '@/components/SPTableBase/effect';
import ProductSearch from './component/ProductSearch';
import { useTargetTableColumns, useLinShowModalSelect, useSetLabel, useGetLabelByEdit, useSetFilter, useFetchData } from './effect';
import { COLUMN_FROM } from '../../effects/consts';
import { RecordSelectLinkShowModalProps } from './type';
import styles from './index.module.less';
import memo from '../memo';

const { Search } = Input;

export const ProductSelelct: FC<RecordSelectLinkShowModalProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  storeValue,
  setRowData,
  allowClear,
  disabled,
  moduleInfo,
}) => {
  const { dispatchEvent, destroyEvent, taskInfo, emitEvent } = config.metaStore || {};
  const [customCode, setcustomCode] = useState<any>('');
  const [onlyCode, setonlyCode] = useState<any>('');
  const [status, setStatus] = useState<any>('');
  const [chooseItems, setChooseItems] = useState<any>({});
  const [nodeType, setNodeType] = useState<string>('');
  const paramsRef = useRef<Record<any, any>>({});
  const { value: fieldName, isMulti, sceneType, customKey, onlyCodeKey } = field?.bizConfig || {};
  // 回显值设置
  const { showLabel, setShowLabel, optionList, setOptionList } = useSetLabel();
  // 交互处理
  const { linkShowModalContrulor, showLinkShowModal, onModalEnter, setInputLabel } = useLinShowModalSelect({ setShowLabel, API, isMulti, setOptionList, emitEvent, moduleInfo });
  // 初始化时回显值处理
  useGetLabelByEdit({ value, field, form, config, columnFrom, setInputLabel, API, setOptionList });

  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys(storeValue).forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }
    setcustomCode(headData?.[customKey]);
    setonlyCode(headData?.[onlyCodeKey]);

    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const cusEvents = [{
      code: field.name,
      name: field.label,
      touchConfig: 'change',
      actionType: 'callback',
      moduleName: mainModuleCode,
      fieldName: customKey,
      fun: (value: any) => {
        setcustomCode(value);
      },
    }];
    const cusIds = dispatchEvent?.(cusEvents);
    const onlyEvents = [{
      code: field.name,
      name: field.label,
      touchConfig: 'change',
      actionType: 'callback',
      moduleName: mainModuleCode,
      fieldName: onlyCodeKey,
      fun: (value: any) => {
        setonlyCode(value);
      },
    }];
    const onlyIds = dispatchEvent?.(onlyEvents);
    return () => {
      destroyEvent?.(cusIds);
      destroyEvent?.(onlyIds);
    };
  }, []);

  // let fieldError: any[];
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   const tableValid = form.getFieldsError().find((item: any) => item.name[0] === config.rowIndex && item.name[1] === field.name)
  //   fieldError = tableValid?.errors || []
  // } else {
  //   fieldError = form.getFieldError(field.name)
  // }

  // useEffect(() => {
  //   if (fieldError?.length > 0) {
  //     setStatus('error')
  //   } else {
  //     setStatus('')
  //   }
  // }, [fieldError]);

  const chooseProduct = (data: any, type: string) => {
    setChooseItems(data);
    setNodeType(type);
  };

  return (
    <>
      <div style={{ display: 'flex', minWidth: '100px' }}>
        <Select
          className={styles.product_select}
          status={status}
          // showSearch
          showArrow={false}
          filterOption={false}
          onChange={(val) => {
            onChange?.(val);
          }}
          notFoundContent='请点击放大镜搜索'
          value={value}
          options={optionList}
          fieldNames={{
            label: 'name',
            value: 'code',
          }}
          allowClear={allowClear !== false}
          disabled={disabled}
        />
        <Button
          onClick={() => {
            // if (!customKey || !onlyCodeKey) {
            //   message.error('请先配置客户经营组织与编号');
            //   return;
            // }
            if (!customCode && customKey) {
              message.error('请先选择客户');
              return;
            }
            linkShowModalContrulor(true)
          }}
          danger={status === 'error'}
          style={{ borderLeft: 'unset' }}
          icon={<SearchOutlined />}
          disabled={disabled}
        />
      </div>
      {showLinkShowModal &&
        <Modal
          visible
          forceRender
          onCancel={() => linkShowModalContrulor(false)}
          width="70vw"
          okText="确认选择"
          cancelText="取消"
          maskClosable={false}
          onOk={() =>
            onModalEnter({
              fieldName,
              onChange,
              form,
              config,
              field,
              columnFrom,
              chooseItems,
              nodeType,
              customCode,
              onlyCode,
              setRowData,
            })
          }
        >
          <ProductSearch
            field={field}
            config={config}
            columnFrom={columnFrom}
            setRowData={setRowData}
            customCode={customCode}
            onlyCode={onlyCode}
            sceneType={sceneType}
            chooseProduct={chooseProduct}
            linkShowModalContrulor={linkShowModalContrulor}
            onChange={onChange}
            setOptionList={setOptionList}
            moduleInfo={moduleInfo}
          />
        </Modal>
      }
    </>
  );
};

export default ProductSelelct;
// export default memo(ProductSelelct);
